import { Component, Input} from '@angular/core';

@Component({
    selector: 'app-on-call-shift-status',
    template: `
<span class="badge"
        [class.text-bg-secondary]="code == 'Submitted'"
        [class.text-bg-light]="code == 'Draft'"
        [class.text-bg-success]="code == 'APST'"
        [class.text-bg-warning]="code == 'ATC'"
        [class.text-bg-danger]="code == 'NOR'">
    {{text || ('onCallShift_status' + code | translate)}}
</span>
`
})
export class OnCallShiftStatusComponent {
    @Input() code: string;
    @Input() text: string;
}
